<div class="{{cardClasses}}"
  attr.id="{{panel.id + '_widget'}}"
  attr.data-automation-id="lm-{{panel.automationId}}-widget"
  >

  <div class="card-header">
    <h2 soho-widget-title
      [ngStyle]="{'display': 'inline-block'}"
      [ngClass]="{'hasOverviewClass': (hasOverviewNavigation && displayLinkAsText), 'widget-title': true }"
      attr.id="{{panel.id}}_widget_title"
      attr.data-automation-id="lm-{{panel.automationId}}-widget-title"
      ><lm-widget-title [title]="panel.title"></lm-widget-title></h2>
      @if (!drillAroundWindow) {
        <div class="panelNavigation">
          @if (hasOverviewNavigation && !displayLinkAsText) {
            <button
              soho-button="icon"
              icon="right-arrow"
              soho-tooltip [content]="overNavigationLink"
              (click)="onNavigationClick($event)"
              attr.id="{{panel.id}}_overview_navigation"
              attr.data-automation-id="lm-{{panel.automationId}}-overview-navigation"
            ></button>
          }
          @if (hasOverviewNavigation && displayLinkAsText) {
            <a
              soho-hyperlink
              attr.aria-label="{{panel.title}} - {{overNavigationLink}}"
              [attr.tabindex]="isInAccessibilityMode ? 0 : null"
              class="lm-hyperlink"
              (click)="onNavigationClick($event)"
              (keydown.enter)="onNavigationClick($event)"
              attr.id="{{panel.id}}_overview_navigation"
              attr.data-automation-id="lm-{{panel.automationId}}-overview-navigation"
            >{{overNavigationLink}}</a>
          }
        </div>
      }
    </div>

    <div class="card-content" [innerHtml]="columnInfo | safe" (click)="onWidgetContentClick($event)"></div>
  </div>
